<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <span class="text-h6">Szállás igények</span>

      <v-spacer />

      <!-- SELF-CONTAINED dialog component -->
      <AdminAccommodationInquiryFormDialog
        @inquiry-created="handleInquiryCreated"
      ></AdminAccommodationInquiryFormDialog>
    </v-card-title>
    <template v-slot:text>
      <v-row dense>
        <v-col cols="12" sm="8">
          <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="statusFilter"
            :items="statusOptions"
            label="Státusz"
            variant="outlined"
            hide-details
            clearable
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :sort-by="[{ key: 'lastModification', order: 'desc' }]"
      :search="normalizedSearch"
    >
      <!-- Public reference formatting (presentation only) -->
      <template v-slot:[`item.publicReference`]="{ item }">
        <span style="font-family: monospace">
          {{ formatPublicReference(item.publicReference) }}
        </span>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-chip
          color="blue"
          text="Részletek"
          @click="() => handleViewClick(item.id)"
        >
        </v-chip>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{ inquiryStatusLabel(item.status) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, toRefs, computed } from "vue";
import { useRoute } from "vue-router";
import router from "@/router";
import AdminAccommodationInquiryFormDialog from "@/components/AccommodationInquiries/admin/AdminAccommodationInquiryFormDialog.vue";
import { formatPublicReference } from "@/utils/formatReference";
import {
  inquiryStatusLabel,
  INQUIRY_STATUS_LABELS,
} from "@/utils/statusLabels";

export default defineComponent({
  name: "AdminAccommodationInquiries",
  props: {
    accommodationInquiries: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  components: {
    AdminAccommodationInquiryFormDialog,
  },
  emits: ["inquiryCreated"],
  setup(props, { emit }) {
    const route = useRoute();
    const search = ref("");
    const normalizedSearch = computed(() => search.value.replace(/-/g, ""));
    const statusFilter = ref<string | null>(
      (route.query.status as string) || null
    );
    const { accommodationInquiries: propAccommodationInquiries } =
      toRefs(props);

    const statusOptions = Object.entries(INQUIRY_STATUS_LABELS).map(
      ([value, title]) => ({ title, value })
    );

    const filteredItems = computed(() => {
      if (!statusFilter.value) return propAccommodationInquiries.value;
      return propAccommodationInquiries.value.filter(
        (i) => i.status === statusFilter.value
      );
    });

    const headers = ref([
      { title: "Referencia", value: "publicReference", sortable: false },
      { title: "Cég", value: "companyName", sortable: true },
      { title: "Felhasználó", value: "userEmail", sortable: true },
      { title: "Költséghely", value: "costCenterName", sortable: true },
      { title: "Helység", value: "area", sortable: true },
      { title: "Létrehozva", value: "createdAt", sortable: true },
      { title: "Utolsó módosítás", value: "lastModification", sortable: true },
      { title: "Érkezés", value: "from", sortable: true },
      { title: "Távozás", value: "to", sortable: true },
      { title: "Létszám", value: "numberOfPeople", sortable: true },
      { title: "Státusz", value: "status", sortable: true },
      { title: "Részletek", value: "id", sortable: true },
    ]);

    const handleInquiryCreated = () => {
      emit("inquiryCreated");
    };
    return {
      headers,
      // eslint-disable-next-line vue/no-dupe-keys
      accommodationInquiries: propAccommodationInquiries,
      handleViewClick: (id: number) => {
        console.log(id);
        router.push("/admin/inquiry/details/" + id);
      },
      search: search,
      normalizedSearch,
      statusFilter,
      statusOptions,
      filteredItems,
      formatPublicReference,
      handleInquiryCreated,
      inquiryStatusLabel,
    };
  },
});
</script>

<style scoped></style>
